import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { IITH, SERIF, SANS } from './iithBrand';

export default function LandingAbout({ name, primary, aboutLong, highlights }) {
  const accent = primary || IITH.saffron;
  const paras = (aboutLong && aboutLong.trim())
    ? aboutLong.split('\n').filter(Boolean)
    : IITH.about;
  const points = highlights?.length ? highlights : IITH.highlights;

  return (
    <section id="about" className="py-20 sm:py-24" style={{ background: IITH.ink }}>
      <div className="max-w-6xl mx-auto px-5 sm:px-6 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-7 space-y-5">
          <p className="text-[11px] uppercase tracking-[0.22em]" style={{ color: IITH.gold }}>About the hospital</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight leading-tight text-white" style={{ fontFamily: SERIF }}>
            Healthcare for the{' '}
            <span style={{ color: accent }}>IITH community</span>
          </h2>
          <div className="leading-relaxed space-y-4 text-[15px]" style={{ color: IITH.mist, fontFamily: SANS }} data-testid="landing-about-long">
            {paras.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <p className="text-[13px]" style={{ color: IITH.mute }}>
              {name || IITH.hospital} · {IITH.institute}
            </p>
          </div>
        </div>
        <div className="lg:col-span-5">
          <div className="border border-white/10 p-6 sm:p-7" style={{ background: IITH.navyMid }}>
            <p className="text-[11px] uppercase tracking-[0.22em] mb-4" style={{ color: accent }}>
              What you can expect
            </p>
            <ul className="space-y-3.5">
              {points.map((h, i) => (
                <li key={i} className="flex gap-3 items-start" data-testid={`landing-highlight-${i}`}>
                  <CheckCircle2 className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: accent }} />
                  <span className="text-[14px] leading-relaxed" style={{ color: IITH.mist }}>{h}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
